"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchActionbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const detail_action_button_1 = require("../../../composite/action-button/detail/detail-action-button");
const detail_actionbar_button_1 = require("../../../composite/detail/detail-actionbar-button");
const detail_context_1 = require("../../../composite/detail/detail-context");
const ess_types_1 = require("../ess-types");
const dispatches_api_1 = require("./dispatches-api");
function DispatchActionbar({ url }) {
    var _a, _b;
    const intl = (0, react_intl_1.useIntl)();
    const { source } = (0, react_1.useContext)(detail_context_1.DetailContext);
    const send = (0, react_1.useMemo)(() => (0, dispatches_api_1.sendFactory)(url), [url]);
    const deliver = (0, react_1.useMemo)(() => (0, dispatches_api_1.deliverFactory)(url), [url]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ((_a = source.data) === null || _a === void 0 ? void 0 : _a.state) === ess_types_1.DispatchState.CREATED && (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "ESS_DISPATCH_SEND", apiCall: send, buttonLabel: intl.formatMessage({
                id: 'ESS_DISPATCH_TOOLBAR_BTN_SEND',
                defaultMessage: 'Odeslat',
            }), buttonTooltip: intl.formatMessage({
                id: 'ESS_DISPATCH_TOOLBAR_TOOLTIP_SEND',
                defaultMessage: 'Otevrě dialog s ručním odesláním',
            }), dialogTitle: intl.formatMessage({
                id: 'ESS_DISPATCH_SEND_DIALOG_TITLE',
                defaultMessage: 'Varování',
            }), dialogText: intl.formatMessage({
                id: 'ESS_DISPATCH_SEND_DIALOG_TEXT',
                defaultMessage: 'Skutečně chcete označit vypravení za odeslané ?',
            }), ButtonComponent: detail_actionbar_button_1.PrimaryDetailActionbarButton })),
        ((_b = source.data) === null || _b === void 0 ? void 0 : _b.state) === ess_types_1.DispatchState.SENT && (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "ESS_DISPATCH_DELIVER", apiCall: deliver, buttonLabel: intl.formatMessage({
                id: 'ESS_DISPATCH_TOOLBAR_BTN_DELIVER',
                defaultMessage: 'Doručit',
            }), buttonTooltip: intl.formatMessage({
                id: 'ESS_DISPATCH_TOOLBAR_TOOLTIP_DELIVER',
                defaultMessage: 'Otevrě dialog s ručním doručením',
            }), dialogTitle: intl.formatMessage({
                id: 'ESS_DISPATCH_DELIVER_DIALOG_TITLE',
                defaultMessage: 'Varování',
            }), dialogText: intl.formatMessage({
                id: 'ESS_DISPATCH_DELIVER_DIALOG_TEXT',
                defaultMessage: 'Skutečně chcete označit vypravení za doručené ?',
            }), ButtonComponent: detail_actionbar_button_1.PrimaryDetailActionbarButton }))));
}
exports.DispatchActionbar = DispatchActionbar;
//# sourceMappingURL=dispatches-actionbar.js.map